import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BeneficioState } from './beneficio.reducer';
import * as fromBeneficio from './beneficio.reducer';

export const beneficioState = createFeatureSelector<BeneficioState>( "beneficio" );

export const beneficioAll = createSelector(
	beneficioState,
	fromBeneficio.selectAll
);

export const beneficioReady = createSelector(
	beneficioState,
	state => state.beneficiosReady
)

export const beneficioMorePagesToLoad = createSelector(
	beneficioState,
	state => state.morePagesToLoad
)

export const beneficioNextPageNum = createSelector(
	beneficioState,
	state => state.nextPageNum
);

export const beneficioPageSize = createSelector(
	beneficioState,
	state => state.pageSize
);

export const beneficioStatus = createSelector(
	beneficioState,
	state => state.status
)

export const beneficioCleared = createSelector(
	beneficioState,
	state => state.cleared
)

export const beneficioInitialized = createSelector(
	beneficioState,
	state => state.initialized
)

export const beneficioCategorias = createSelector(
	beneficioState,
	state => state.categorias
)

export const beneficioCategoriaSelected = createSelector(
	beneficioState,
	state => state.categoriaSelected
)

export const categoriaReady = createSelector(
	beneficioState,
	state => state.categoriasReady
);

export const ready = createSelector(
	beneficioReady,
	categoriaReady,
	( beneficioReady, categoriaReady ) => beneficioReady && categoriaReady
);